/**
 * Progressive enhancement for the product form.
 *
 * Without this file the page still works: the <select name="id"> submits the
 * chosen variant and the server renders the correct price. This only avoids
 * the page load when switching variants.
 */
(function () {
  'use strict';

  var select = document.querySelector('[data-variant-select]');
  if (!select) return;

  var priceEl = document.querySelector('[data-price]');
  var addButton = document.querySelector('[data-add-button]');
  if (!priceEl || !addButton) return;

  var currentEl = priceEl.querySelector('.product__price-current');
  var compareEl = priceEl.querySelector('.product__price-compare');
  var addLabel = addButton.textContent.trim();
  var soldOutLabel = addButton.getAttribute('data-sold-out-label') || 'Sold out';

  select.addEventListener('change', function () {
    var option = select.options[select.selectedIndex];
    if (!option) return;

    var price = option.getAttribute('data-price');
    var compare = option.getAttribute('data-compare');
    var available = option.getAttribute('data-available') === 'true';

    if (currentEl && price) currentEl.textContent = price;

    if (compareEl) {
      if (compare) {
        compareEl.textContent = compare;
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }

    addButton.disabled = !available;
    addButton.textContent = available ? addLabel : soldOutLabel;

    // Keep the address bar in step so the variant can be linked and shared.
    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url.toString());
    }
  });
})();

/**
 * Sticky add-to-cart bar. It appears once the main Add to cart button has
 * scrolled out of view, and submits the main form so the cart drawer handles
 * the add exactly as it does for the main button.
 */
(function () {
  'use strict';

  var bar = document.querySelector('[data-product-sticky]');
  var buttons = document.querySelector('.product__buttons');
  if (!bar || !buttons || !('IntersectionObserver' in window)) return;

  var form = buttons.closest('form');
  var mainButton = buttons.querySelector('[data-add-button]');
  var stickyButton = bar.querySelector('[data-product-sticky-add]');

  new IntersectionObserver(function (entries) {
    var entry = entries[0];
    // Show only once the button is above the viewport, not before reaching it.
    var past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
    bar.classList.toggle('is-visible', past);
  }).observe(buttons);

  if (stickyButton && form && mainButton) {
    stickyButton.addEventListener('click', function () {
      if (mainButton.disabled) return;
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(mainButton);
      } else {
        mainButton.click();
      }
    });
  }
})();
